import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-motivos-no-entrega-tabla',
  templateUrl: './motivos-no-entrega-tabla.component.html',
  styleUrls: ['./motivos-no-entrega-tabla.component.scss']
})
export class MotivosNoEntregaTablaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
